// extracted by mini-css-extract-plugin
export default {"mobileNav":"mobileNav-module--mobileNav--2RZ3a"};